<template lang="pug">
  .cart-item
    div(v-if="getQuantity()")
      v-row(no-gutters)
        v-col.shrink.py-3
          v-img(:src="productData.image ? `https://img.yezza.io/120x120/${productData.image.path}` : require('@/assets/images/image_placeholder.png')" max-width="48px" width="48px" height="48px")
        v-col.py-3.pl-2
          v-row(no-gutters)
            v-col(cols="7")
              div.p2.primary--text(v-if="!productData.variant_for") {{ (productData.display_name || product.name) | capitalize }}
              .addons-layout(v-if="product.addons")
                div(v-for="(item, index) in product.addons.filter(item => item.quantity_per_set > 0)" :key="'addon-' + index")
                  div.c1.basic600--text.mt-1 + {{ item.product.name }} {{ item.quantity_per_set > 1 ? 'x ' + item.quantity_per_set : '' }}
              
              .bundles-layout(v-if="productData.has_bundles")
                template(v-for="(item, index) in product.bundles")
                  div.c1.basic600--text.mt-1(:key="'bundle-' + index") {{ index + 1 }}. {{ (item.product.display_name || item.product.name) }}
                  .notes-layout(v-if="item.product.product_notes_data && item.product.product_notes_data.length > 0")
                    div(v-for="(pnitem, index) in item.product.product_notes_data" :key="'note-' + index")
                      div.basic600--text.c1.ml-2 - 
                        strong {{ pnitem.name }}: 
                        | {{ pnitem.data }}

              .variants-layout(v-if="productData.variant_for")
                div.p2.primary--text {{ productData.parent_product.name | capitalize }}
                div.c1.basic600--text.mt-1 {{ productData.name }}

              .notes-layout.mt-1(v-if="product.product_notes_data && product.product_notes_data.length > 0")
                div(v-for="(item, index) in product.product_notes_data" :key="'note-' + index")
                  div.basic600--text.c1
                    strong {{ item.name }}: 
                    | {{ item.data }}

            v-col(cols="1")
              div.p2.primary-text.text-center {{ getQuantity() }}
            v-col(cols="4")
              div.p2.primary-text.text-right {{ getProductPrice() | displayPrice($currency) }}
              div.button-Aa-small.info500--text.mt-1.clickable.text-right(@click="openEditProduct(productData)") {{ $t('edit') }}
            
    .product(style="max-width:500px")
      product(v-if="openProduct" :open.sync="openProduct" :product="product")

    .productAddons(style="max-width:500px")
      addons(v-if="openAddons" :open.sync="openAddons" :product="product")

</template>

<script>
import { mapGetters } from 'vuex'
import Product from '@/components/cart/Product.vue'
import Addons from '@/components/cart/Addons.vue'

export default {
  name: 'TmpCartItem',
  components: { Product, Addons },
  props: {
    product: {
      type: Object,
      default: null
    }
  },
  data: () => ({
    showAddProductDialog: false,
    openProduct: false,
    openVariants: false,
    openAddons: false,
  }),
  computed: {
    ...mapGetters({
      cart: 'cart/getCart'
    }),
    productData () {
      return this.product.product
    }
  },
  methods: {
    getProductPrice () {
      let price = this.product.price || this.productData.price
      if (this.product.addons) {
        this.product.addons.forEach((item) => {
          price += item.product.price * item.quantity_per_set
        })
      }
      return price * this.product.quantity
    },
    getQuantity () {
      return this.product.quantity
    },
    openEditProduct (product) {
      this.$store.commit('cart/syncTmpCart')
      if (product.has_addons) {
        this.openAddons = true
      } else {
        this.openProduct = true
      }
    }
  }
}
</script>

<style scoped>
.quantity-box {
  border: 1px solid black;
  border-radius: 6px;
  height: 24px;
  width: 46px;
  color: #D11184;
}
</style>
